export default __webpack_public_path__ + "static/cotorreo-5781ef2d8171163ece45fc088446dfab.png";